<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="itemId">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <!-- Что произойдёт — словами. Кнопка «Вернуть» без этого выглядит как
                     действие без последствий, а она снимает держателя и переводит
                     технику на склад. -->
                <p class="inventory-action-modal__hint">
                    Оборудование перестанет числиться за
                    <strong>{{ holderName }}</strong>
                    и вернётся на склад.
                </p>

                <!-- Одно поле, и то необязательное: кто возвращает и от кого, сервер
                     знает из самой карточки — присылать это с формы нельзя, она могла
                     быть открыта час назад. -->
                <ValidationProvider class="active-form__field" name="return-comment" v-slot="{ errors }">
                    <label class="active-form__label" for="return-comment">Комментарий</label>

                    <VInput
                        id="return-comment"
                        name="return-comment"
                        class="active-form__control"
                        placeholder="Например: вернул без блока питания"
                        :disabled="isSaving"
                        v-model="comment"
                    ></VInput>

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <p class="active-form__error inventory-action-modal__error" v-if="error">{{ error }}</p>

                <div class="active-form__actions">
                    <VButton
                        type="button"
                        class="active-form__action button_green-light"
                        :disabled="isSaving"
                        @click="hide"
                    >
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green" :disabled="isSaving">
                        {{ isSaving ? 'Сохраняем…' : 'Вернуть' }}
                    </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import { returnInventoryItem } from '../../../../js/inventory-api';
import { errorMessage } from '../../../../js/error';

/**
 * Возврат оборудования на склад (7-F2A).
 *
 * ПОДТВЕРЖДЕНИЕ, А НЕ ФОРМА. Выбирать здесь нечего: держателя снимаем, статус переводим
 * на складской, и то и другое известно из карточки. Единственное поле — комментарий,
 * и он необязателен: обязательную «причину» заполняют точкой.
 *
 * ОТДЕЛЬНОЕ ОКНО, А НЕ CONFIRM. Простое подтверждение не даёт записать, в каком виде
 * вещь вернулась, — а именно это потом ищут в истории при разборе спорной ситуации.
 *
 * Запрос делает окно: отказ сервера показывается здесь же, вместе с введённым текстом.
 */
@Component({
    components: {
        VInput,
        VButton,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryItemReturnModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_ITEM_RETURN })
    name;
    @Prop({ type: String, default: 'Возврат на склад' })
    defaultTitle;

    itemId = null;
    holderName = '';
    comment = '';
    error = '';
    isSaving = false;

    async submit() {
        if (this.isSaving || !this.itemId) {
            return;
        }

        this.isSaving = true;
        this.error = '';

        try {
            const response = await returnInventoryItem(this.itemId, { comment: this.comment });

            this.resolve(response.data);
            this.hide();
        } catch (requestError) {
            this.error = errorMessage(requestError);
        } finally {
            this.isSaving = false;
        }
    }

    beforeOpen(event) {
        const params = event?.params ?? {};

        this.itemId = params.itemId ?? null;
        // Имя держателя приходит параметром, а не запрашивается: карточка его уже
        // показывает, и второй запрос за тем же самым ничего не добавит.
        this.holderName = params.holderName || 'текущим держателем';
        this.comment = '';
        this.error = '';
        this.isSaving = false;
    }

    beforeClose() {
        this.itemId = null;
        this.comment = '';
        this.error = '';
    }
}

export default VInventoryItemReturnModal;
</script>
